import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { Icon, Icons } from "../../../../../atoms/icon";
import { HeaderVariants, Tags, Typography, } from "../../../../../atoms/typography";
import { Favorite } from "../../../../../molecules/favorites";
import { useUser } from "../../../../../../utils/hooks";
import Strings from "../../../../../../utils/hardcoded.json";
import styles from "../styles.css";
const OverlayD = ({ descriptionM, isFavorite, read, category, id, webAuthRedirectionUrl, index, route, showGenre, name, contentGenre, }) => {
    const { isAnonymous } = useUser();
    // const KidsOverlay = () => {
    //   return (
    //     <div className={styles.kidsHoverContainer}>
    //       <div className={styles.kidsPlayIconWrapper} id="#play-icon">
    //         <Icon
    //           type={Icons.PlayIcon}
    //           className={styles.basiCardhoverPlayIcon}
    //           color="black"
    //         />
    //       </div>
    //     </div>
    //   );
    // };
    const DefaultOverlay = () => {
        return (React.createElement("div", { className: cn(styles.hoverOverlay, {
                [styles.twoDigitsRailCard]: index >= 10,
            }) },
            React.createElement("div", { className: styles.basicHoverPlayIconWrapper, id: "#play-icon" },
                React.createElement(Icon, { type: Icons.HoverPlayIcon, className: styles.basiCardhoverPlayIcon, color: "black" })),
            React.createElement("div", { className: styles.hoverWrapper },
                React.createElement("div", { className: styles.baicHoverContent },
                    React.createElement(Typography, { variant: HeaderVariants.headingSix, tag: Tags.h6, classNameM: M.of(styles.basicShowName) },
                        React.createElement(React.Fragment, null, name)),
                    React.createElement("div", { className: styles.basicDescwrapper },
                        React.createElement(RenderMaybe, null, M.map((description) => (React.createElement(Typography, { variant: HeaderVariants.subHeadTwo, tag: Tags.span, classNameM: M.of(styles.basicShowDesc) },
                            React.createElement(React.Fragment, null, description))), descriptionM)),
                        React.createElement("div", { className: styles.actionButton, id: isFavorite ? Strings.LIKE : Strings.UNLIKE },
                            React.createElement(Favorite, { read: read, id: id, isFavorite: isFavorite, anonymous: isAnonymous, type: category, webAuthUrl: webAuthRedirectionUrl, route: route, contentGenre: contentGenre, showGenre: showGenre })))))));
    };
    const Overlay = () => {
        // switch (theme) {
        //   case THEME.KIDS:
        //     return <DefaultOverlay />;
        //   default:
        return React.createElement(DefaultOverlay, null);
        // }
    };
    return React.createElement(Overlay, null);
};
export default OverlayD;

